export type ReportType = 'sender' | 'beneficiary';

export interface SenderReportFilter {
  from_date?: string;
  to_date?: string;
  cumulative_amount?: number | string;
  cumulative_amount_op?: string;
  source_country?: string;
  destination_country?: string;
  transfer_type?: string;
  country_of_birth?: string;
  beneficiary_id?: number | string;
  partner_id?: number;
}

export interface BeneficiaryReportFilter {
  from_date?: string;
  to_date?: string;
  amount_type?: string;
  cumulative_amount?: number | string;
  cumulative_amount_op?: string;
  source_country?: string;
  destination_country?: string;
  transfer_type?: string;
  partner_id?: number;
}

export const AMOUNT_OPERATORS = [
  { name: 'Greater than (>)', value: '>' },
  { name: 'Less than (<)', value: '<' },
  { name: 'Equal to (=)', value: '=' },
];

export const AMOUNT_TYPES = [
  { name: 'Source', value: 'source' },
  { name: 'Destination', value: 'destination' },
];
